import React, { FC, ReactNode, useRef } from "react";
import { InputNumber } from "antd";
import { InputNumberProps } from "antd/lib/input-number";

export interface InputPriceProps extends InputNumberProps {
  className?: string;
  min?: number;
  suffix?: ReactNode;
  prefix?: ReactNode;
  disableParsingAndFormatting?: boolean;
}

const locale = "da-DK";

const InputNum: FC<InputPriceProps> = ({ suffix, prefix, className, min, disableParsingAndFormatting, ...rest }) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const suffixRef = useRef<HTMLSpanElement>(null);
  const prefixRef = useRef<HTMLSpanElement>(null);

  const hasMinus = typeof min === "undefined" || (min && min < 0);

  const numFormatter = (value?: number | string) => {
    if (!value) return "";
    if (hasMinus && value === "-") return "-";
    const res = new Intl.NumberFormat(locale).format(Number(value));
    return res.split(",")[0];
  };

  const numParser = (val?: string) => {
    if (!val || (typeof val === "string" && !val.length)) return "";
    let minus = "";

    if (hasMinus && (val.startsWith("-") || val === "0-")) {
      minus = "-";
      if (val.length === 1) return minus;
    }

    try {
      val = val.split(",")[0];
      val = val.replace(/[^0-9]/g, "");
      return `${minus}${val.length ? val : ""}`;
    } catch (error) {
      console.error(error);
      return "";
    }
  };

  const inputElement = () => {
    const paddingRight = suffixRef.current?.offsetWidth ? suffixRef.current?.offsetWidth + 8 : "1rem";
    const paddingLeft = prefixRef.current?.offsetWidth ? prefixRef.current?.offsetWidth + 8 : 0;
    return (
      <InputNumber
        {...rest}
        className={`no-steps-btns ${className ? className : ""}`}
        style={{
          width: 400,
          paddingRight,
          paddingLeft,
          ...rest.style
        }}
        min={min}
        formatter={disableParsingAndFormatting ? undefined : numFormatter}
        parser={disableParsingAndFormatting ? undefined : numParser}
        ref={inputRef}
      />
    );
  };

  return (!!suffix || !!prefix) ? (
    <div className="input-number-wp">
      {prefix && (
        <span ref={prefixRef} onClick={() => inputRef.current?.focus()} className="input-number-prefix">
          {prefix}
        </span>
      )}
      {inputElement()}
      {suffix && (
        <span ref={suffixRef} onClick={() => inputRef.current?.focus()} className="input-number-extra">
          {suffix}
        </span>
      )}
    </div>
  ) : (
    inputElement()
  );
  /*   return (
    <InputNumber
      {...rest}
      className={`${className} no-steps-btns`}
      style={{
        width: 400,
        marginRight: "1rem",
      }}
      min={min}
      formatter={numFormatter}
      parser={numParser}
    />
  ); */
};

export default InputNum;
